/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { WorkflowState } from "./workflow-state";
import { RequestStageDto } from "./request-stage-dto";

export class WorkflowContextDto {
    workflowContextId: string = undefined;
    state: WorkflowState;
    data: any;
    nextAction: string = undefined;
    waitUntil: Date = undefined;
    stage: string = undefined;
    step: string = undefined;
    active: boolean = undefined;
    stages: RequestStageDto[];
}
